import { useState, useEffect } from 'react'
import { Bell, BellOff, BellRing, Loader2 } from 'lucide-react'
import { toast } from 'sonner'
import * as push from '@/lib/pushNotifications'

export function NotificationToggle() {
  const [status, setStatus] = useState<'granted' | 'denied' | 'default' | 'unsupported'>('default')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    push.getStatus().then(setStatus)
  }, [])

  if (status === 'unsupported') return null

  async function toggle() {
    setLoading(true)
    try {
      if (status === 'granted') {
        await push.unsubscribe()
        setStatus('default')
        toast.success('Notifications disabled')
      } else {
        const ok = await push.subscribe()
        if (ok) {
          setStatus('granted')
          toast.success('Notifications enabled')
        } else {
          const current = await push.getStatus()
          setStatus(current)
          if (current === 'denied') {
            toast.error('Notifications blocked. Enable them in your browser settings.')
          }
        }
      }
    } catch {
      toast.error('Failed to update notifications')
    } finally {
      setLoading(false)
    }
  }

  const Icon = loading ? Loader2 : status === 'granted' ? BellRing : status === 'denied' ? BellOff : Bell

  return (
    <button
      onClick={toggle}
      disabled={loading || status === 'denied'}
      className="text-muted-foreground hover:text-foreground transition-colors p-2.5 disabled:opacity-50"
      aria-label={status === 'granted' ? 'Disable notifications' : 'Enable notifications'}
      title={
        status === 'granted' ? 'Notifications on — tap to disable'
        : status === 'denied' ? 'Notifications blocked by browser'
        : 'Enable notifications'
      }
    >
      <Icon
        className={`w-5 h-5 ${loading ? 'animate-spin' : ''} ${status === 'granted' ? 'text-primary' : ''}`}
        strokeWidth={2}
      />
    </button>
  )
}
